<template>
  <b-row>
    <b-col lg="12">
      <table class="table b-table table-fixed">
        <!-- Génération du header -->
        <thead role="rowgroup">
          <tr role="row">
            <th v-if="numbering" role="columnheader" scope="col">#</th>
            <th
              v-for="(field, field_index) in fields"
              :key="field_index"
              role="columnheader"
              scope="col"
            >
              <div>{{ field.label || field.key }}</div>
            </th>
            <th class="text-center" role="columnheader" scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, row_index) in value" :key="row_index" scope="row">
            <td v-if="numbering" style="vertical-align: middle">
              <strong>#{{ row_index + 1 }}</strong>
            </td>
            <td
              v-for="(col, col_index) in fields"
              :key="row_index + '-' + col_index"
            >
              <b-input-group
                v-if="fields[col_index].type == 'varchar'"
                :append="
                  fields[col_index].append ? fields[col_index].append : ''
                "
              >
                <b-input
                  :state="value[row_index][fields[col_index].key].state"
                  @blur="validate()"
                  @keydown.tab.native="tab(row_index, col_index, $event)"
                  type="text"
                  v-model="value[row_index][fields[col_index].key].value"
                ></b-input>
              </b-input-group>
              <b-input-group v-if="fields[col_index].type == 'date'">
                <b-input
                  @keydown.tab.native="tab(row_index, col_index, $event)"
                  @blur="validate()"
                  placeholder="AAAA-mm-jj"
                  type="text"
                  :state="value[row_index][fields[col_index].key].state"
                  v-model="value[row_index][fields[col_index].key].value"
                ></b-input>
              </b-input-group>
              <b-input-group
                v-if="
                  fields[col_index].type == 'int' ||
                  fields[col_index].type == 'float'
                "
                :append="
                  fields[col_index].append ? fields[col_index].append : ''
                "
              >
                <b-input
                  class="text-right"
                  :state="value[row_index][fields[col_index].key].state"
                  @blur="validate()"
                  @keydown.tab.native="tab(row_index, col_index, $event)"
                  type="text"
                  v-model="value[row_index][fields[col_index].key].value"
                ></b-input>
              </b-input-group>
            </td>
            <td
              style="vertical-align: middle; text-align: center; width: 150px"
            >
              <b-button
                tabindex="-1"
                @click="deleteRow(row_index)"
                size="sm"
                variant="danger"
                icon
                ><b-icon-x-circle-fill></b-icon-x-circle-fill
              ></b-button>
              <b-button
                tabindex="-1"
                @click="addEmptyRow()"
                v-if="!isEmptyRow(row_index) && row_index == value.length - 1"
                class="ml-2"
                size="sm"
                variant="success"
                icon
                ><b-icon-plus-circle-fill></b-icon-plus-circle-fill
              ></b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "mh-table-editable",
  props: {
    fields: {
      type: Array,
    },
    value: {
      type: Array,
    },
    numbering: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      render: 0,
    };
  },
  created() {
    if (this.value.length == 0) {
      this.addEmptyRow();
    }
  },

  methods: {
    dateValidation(payload) {
      var date_regex = /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|3[01])$/;
      if (!date_regex.test(payload)) {
        return false;
      }
      return true;
    },
    tab(row_index, col_index, e) {
      if(e.shiftKey) {
        return;
      }
      if (
        col_index == this.fields.length - 1 &&
        row_index == this.value.length - 1 &&
        !this.isEmptyRow(row_index)
      ) {
        this.addEmptyRow();
      }
    },
    validate() {
      let overall_validation = true;
      
      
      for (let row_index = 0; row_index < this.value.length; row_index++) {
        this.fields.forEach((el, col_index) => {
          let val = String(
            this.value[row_index][this.fields[col_index].key].value
          );

          if (el.default !== undefined && val.trim() == "") {
            this.value[row_index][this.fields[col_index].key].value =
              el.default;
          }
          if (el.trigger) {
            this.fields[col_index].trigger(this.value[row_index]);
          }
          if (el.required && val.trim() == "") {
            this.value[row_index][this.fields[col_index].key].state = false;
            overall_validation = false;
          } else if (el.type == "date") {
            this.value[row_index][this.fields[col_index].key].state =
              this.dateValidation(val);
          } else {
            this.value[row_index][this.fields[col_index].key].state = null;
          }
        });
      }
      this.$emit("validation", overall_validation);
    },
    isEmptyRow(row_index) {
      let str = "";
      for (let property in this.value[row_index]) {
        str += this.value[row_index][property].value;
      }
      return str.trim() == "";
    },
    addEmptyRow() {
      let row = {};
      for (let i = 0; i < this.fields.length; i++) {
        row[this.fields[i].key] = { value: "", state: null };
      }
      this.value.push(row);
      this.validate();
    },
    deleteRow(row_index) {
      this.value.splice(row_index, 1);
      if (this.value.length == 0) {
        this.addEmptyRow();
      }
      this.validate();
    },
    updateValue(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>